export default {
    name: 'SummaryBar',
    props: ["total", "totalslots", "registered", "open","double"]

}